module.exports = __webpack_public_path__ + "img/9.822a398f.jpg";